import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { IntlService } from '@progress/kendo-angular-intl';
import { User } from '@app/core/models';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'create-edit-service-output',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="800" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!-- {{ form.value | json }} Es valido: {{ form.valid }} -->
    
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">              
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Fecha y Hora de Salida:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-datepicker formControlName="output_date" [format]="'dd-MMM-yyyy HH:mm'"></kendo-datepicker>
                  </kendo-textbox-container>
                  <div *ngIf="f.output_date.invalid && (f.output_date.dirty || f.output_date.touched)">                  
                    <div *ngIf="f.output_date.errors">
                      <kendo-formerror *ngIf="f.output_date.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Grúa:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_crane" [table]="'cranes'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>
              </div>
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Operador:"></kendo-label>
                  <dynamic-dropdownlist formControlName="id_person_operator" [table]="'persons_operators'" [valueField]="'id'" [textField]="'name'" [showAll]="true"></dynamic-dropdownlist>                  
              </div>              
              <div class="col-xs-6 col-sm-6 example-col">
                  <kendo-label text="Destino:"></kendo-label>
                  <kendo-textbox-container>                                        
                    <dynamic-autocomplete formControlName="place" [table]="'services_inventories'" [valueField]="'place'" [showAll]="true" controlTrim></dynamic-autocomplete>
                  </kendo-textbox-container> 
                  <div *ngIf="f.place.invalid && (f.place.dirty || f.place.touched)">                  
                    <div *ngIf="f.place.errors">
                      <kendo-formerror *ngIf="f.place.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Observaciones:" [optional]="true"></kendo-label>
                  <kendo-textbox-container>
                    <textarea kendoTextArea formControlName="observations" rows="3" controlTrim></textarea>
                  </kendo-textbox-container>
              </div>
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }    
  `],
  providers: [ DatasourceService ]
})    
export class CreateEditServiceOutputComponent extends CreateEditWindowComponent {

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService, protected intl: IntlService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,      
      `Fecha de salida: '${this.intl.formatDate(dataItem.output_date, "yyyy-MM-dd HH:mm")}'`,
      `Grúa: '${dataItem.crane_name}'`,
      `Operador: '${dataItem.person_operator_name}'`,
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    const tzDate = ZonedDate.fromUTCDate((dataItem) ? new Date(dataItem.output_date) : new Date(), environment.timezone);

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),     
      'output_date': new FormControl((dataItem) ? new Date(tzDate.toUTCString().replace('Dev', 'Dec')): new Date(), Validators.required), 
      'place': new FormControl((dataItem) ? dataItem.place: "", Validators.required),
      'id_crane': new FormControl((dataItem) ? dataItem.id_crane: 0, Validators.required),
      'id_person_operator': new FormControl((dataItem) ? dataItem.id_person_operator: 1, Validators.required),
      'id_service_status': new FormControl((dataItem) ? dataItem.id_service_status: 1),
      'observations': new FormControl((dataItem) ? dataItem.observations: ""),
    });

  };

  //@Override
  protected getData(formGroup: FormGroup): Object {
    
    return Object.assign({}, formGroup.value, { 
      output_date: this.intl.formatDate(formGroup.value.output_date, "yyyy-MM-dd HH:mm"),
      // output_date: null
    });

  };

}
